import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import KnoaCardMainRow from '../CardParts/KnoaCardMainRow';

const InfoSelectCard = ({
                            id,
                            isChecked,
                            icon,
                            subHeading,
                            heading,
                            footerText,
                            handleProjectReportsUpdate,
                            mainRowHeight
                        }) => {
    const { t } = useTranslation();

    const safeId = String(id);
    const domSafeId = safeId.replace(/[^a-zA-Z0-9-_]/g, '-'); // for DOM
    const checkboxId = `${domSafeId}-checkbox`;
    const subHeadingId = `${domSafeId}-subheading`;
    const headingId = `${domSafeId}-heading`;
    const footerId = `${domSafeId}-footer`;

    const handleCheckboxClick = () => {
        handleProjectReportsUpdate(safeId, !isChecked);
    };

    return (
        <div className="card shadow-sm mb-3">
            <div className="card-body px-4">
                <div className="form-check mb-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={checkboxId}
                        checked={isChecked}
                        onChange={handleCheckboxClick}
                        aria-labelledby={`${subHeadingId} ${headingId} ${footerText ? footerId : ''}`}
                    />
                    <label className="form-check-label" htmlFor={checkboxId}>
                        {t('Select')}
                    </label>
                </div>

                <KnoaCardMainRow
                    icon={icon}
                    subHeading={{ ...subHeading, id: subHeadingId }}
                    heading={{ ...heading, id: headingId }}
                    mainRowHeight={mainRowHeight}
                />
            </div>

            {footerText && (
                <div className="px-4 pb-3">
                    <hr className="mt-0 mb-2" />
                    <div
                        className="d-flex align-items-center"
                        style={{ minHeight: '48px' }}
                    >
            <span id={footerId} className="text-muted small">
              {footerText}
            </span>
                    </div>
                </div>
            )}
        </div>
    );
};

InfoSelectCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isChecked: PropTypes.bool.isRequired,
    icon: PropTypes.shape({
        name: PropTypes.string.isRequired,
        status: PropTypes.string
    }),
    subHeading: PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        color: PropTypes.string
    }).isRequired,
    heading: PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        color: PropTypes.string
    }).isRequired,
    footerText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    handleProjectReportsUpdate: PropTypes.func.isRequired,
    mainRowHeight: PropTypes.string
};

export default InfoSelectCard;